import React from 'react';
import CardCategory from './cardCategory';
import CardTag from './cardTag';

const Main = props => {
  const {
    categoryId,
    categoryName,
    categories,    
    tags,
    newTagsToSave,
    handleGetTagsByCategoryId,
    handleAddNewTagToSave,
    handleDeleteButton,
    handleCancel,
    handleSave,
    language,
    languageFilters,
    loadingCategories,
    loadingTags
  } = props;

  return (
    <div className="card-flex">
      <CardCategory
        categoryId={categoryId}
        categories={categories}
        handleGetTagsByCategoryId={handleGetTagsByCategoryId}
        language={language}
        languageFilters={languageFilters}
        loading={loadingCategories}
      />

      <CardTag
        categoryId={categoryId}
        categoryName={categoryName}
        tags={tags}
        newTagsToSave={newTagsToSave}
        handleAddNewTagToSave={handleAddNewTagToSave}
        handleDeleteButton={handleDeleteButton}
        handleCancel={handleCancel}
        handleSave={handleSave}
        languageFilters={languageFilters}
        language={language}
        loading={loadingTags}
      />
    </div>
  );
};

export default Main;



// WEBPACK FOOTER //
// ./source/client/components/account_tag/main.jsx